// ********************************************************
// Archive
// Handles common archive loading/saving
// ********************************************************

import * as Backend from '@/core/backend'
export const test1 = 'test1'
export var test2 = 'test2'

export async function loadFacilities () {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadFacilities'
  })
  return res
}

export async function loadArticles (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadArticles',
    inputData: {
      Facility: params
    }
  })
  return res
}

export async function loadCustomers (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadCustomers',
    inputData: {
      Facility: params.facilityNo,
      SearchCriteria: params.searchCriteria,
      Top: params.top
    }
  })
  return res
}

export async function loadCustomer (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadCustomer',
    inputData: {
      Facility: params.facilityNo,
      No: params.customerNo
    }
  })
  return res
}

export async function loadPlants (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadPlants',
    inputData: {
      Facility: params
    }
  })
  return res
}

export async function loadCarriers (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadCarriers',
    inputData: {
      Facility: params
    }
  })
  return res
}

export async function loadProducers (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadProducers',
    inputData: {
      Facility: params
    }
  })
  return res
}

export async function loadVehicles (params) {
  let deleted = true
  // default: load deleted vehicles too, prior to this LoadDeleted was hardcoded to true,
  // resulting in loading vehicle from the archive that were deleted (inactive) in the main system, whiched was a
  // problem for users with vehicle license plate set
  if (params.loadDeleted !== undefined) {
    deleted = params.loadDeleted
  }

  const res = await Backend.callApi({
    apiName: 'Archive.LoadVehicles',
    inputData: {
      // MITH special: If params is '' show all vehicles for all facilities (we use facility = null).
      Facility: params === '' ? null : params.facility,
      SearchText: params.searchText,
      LoadDeleted: deleted // always load Deleted, to be able to show inactive Vehicles
    }
  })

  return res
}

export async function loadVehicle (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadVehicle',
    inputData: {
      Facility: params.facilityNo,
      No: params.vehicleNo
    }
  })
  return res
}

export async function saveVehicle (vehicle) {
  const res = await Backend.callApi({
    apiName: 'Archive.SaveVehicles',
    inputData: {
      Vehicles: [vehicle]
    }
  })

  return res
}

export async function saveVehicles (vehicles) {
  const res = await Backend.callApi({
    apiName: 'Archive.SaveVehicles',
    inputData: {
      Vehicles: vehicles
    }
  })

  return res
}

export async function loadAgreements (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadAgreements',
    inputData: {
      Facility: params.facilityNo,
      SearchCriteria: params.searchCriteria,
      Top: params.top,
      AgreementNoFilter: params.agreementNoFilter,
      DataCode: params.DataCode
    }
  })
  return res
}

export async function loadAgreement (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadAgreements',
    inputData: {
      Facility: params.facilityNo,
      No: params.no,
      SearchCriteria: params.searchCriteria,
      Top: params.top,
      AgreementNoFilter: params.agreementNoFilter,
      DataCode: params.DataCode
    }
  })
  return res
}

export async function loadDeliveries (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadDeliveries',
    inputData: {
      Facility: params.facilityNo,
      AgreementId: params.agreementId
    }
  })
  return res
}

export async function loadStorages (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadStorages',
    inputData: {
      Facility: params
    }
  })
  return res
}
